import { FC } from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { Outlet, useLocation } from "react-router-dom";
import { borderStyle } from "../../../utils/styles/styles";
import HeaderLanding from "../HeaderLanding/HeaderLanding";
import { primaryColor } from "../../../utils/colors";

const LandingLayout: FC = () => {
  const location = useLocation();
  const excludedPaths = ["/", "/login"];

  return (
    <Flex
      as="main"
      minHeight="100vh"
      bg="white"
      position="relative"
      direction="column"
      overflowX="hidden"   // <- novo: evita scroll horizontal
    >
      {/* {!excludedPaths.includes(location.pathname) && (
        <Box backgroundColor={primaryColor}>
          <HeaderLanding />
        </Box>
      )} */}
      {!excludedPaths.includes(location.pathname) && (
        <Box
          backgroundColor={primaryColor}
          position="sticky"
          top="0"
          zIndex="999"
          width="100%"
        >
          <HeaderLanding />
        </Box>
      )}

      <Box flex="1" position="relative" zIndex={1}>
        <Outlet />
      </Box>
      <Box
        height="105px"
        backgroundColor="gray.50"
        borderTop={borderStyle}
        paddingY="6"
        paddingLeft="24"
      >
        <Image
          src="/images/sisan.png"
          alt="Sistema de Informação e Alerta Rápido para a Segurança Alimentar e Nutricional"
          objectFit="contain"
          maxHeight="100%"
          width="auto"
        />
      </Box>
    </Flex>
  );
};

export default LandingLayout;
